import * as types from './imprimirSolicitacao.actionTypes';

export default {
  setTokenRecaptcha: (data) => ({
    type: types.SET_TOKEN_RECAPTCHA,
    payload: data,
  }),
  setTokenRecaptchaModal: (data) => ({
    type: types.SET_TOKEN_RECAPTCHA_MODAL,
    payload: data,
  }),
  toggleModalImprimirSolicitacao: () => ({
    type: types.TOGGLE_MODAL_IMPRIMIR_SOLICITACAO,
  }),
  pesquisarImprimirSolicitacaoModal: (data) => ({
    type: types.PESQUISAR_IMPRIMIR_SOLICITACAO_MODAL,
    payload: data,
  }),
  pesquisarImprimirSolicitacao: (data) => ({
    type: types.PESQUISAR_IMPRIMIR_SOLICITACAO,
    payload: data,
  }),
  abrirImprimirSolicitacao: (data) => ({
    type: types.ABRIR_IMPRIMIR_SOLICITACAO,
    payload: data,
  }),
  setImprimirSolicitacaoGridPesquisa: (data) => ({
    type: types.SET_GRID_PESQUISA_IMPRIMIR_SOLICITACAO,
    payload: data,
  }),
  limpaGridsImprimirSolicitacao: () => ({
    type: types.LIMPA_GRIDS_IMPRIMIR_SOLICITACAO,
  }),
  setRecaptchaResetRef: (data) => ({
    type: types.SET_RECAPTCHA_RESET_REF,
    payload: data,
  }),
  setRecaptchaResetRefModal: (data) => ({
    type: types.SET_RECAPTCHA_RESET_REF_MODAL,
    payload: data,
  }),
};
